import { __assign, __rest } from "tslib";
import React from 'react';
import VeltReactionPinTooltipUsersWireframe from './VeltReactionPinTooltipUsersWireframe/VeltReactionPinTooltipUsersWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltReactionPinTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinTooltipWireframe.Users = VeltReactionPinTooltipUsersWireframe;
export default VeltReactionPinTooltipWireframe;
